/**
 * Fonction qui copie du texte dans le presse-papier.
 * @see https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript/33928558#33928558
 * @param text Texte à copier
 * @return void
 */
function copyToClipboard(text) {
    if (window.clipboardData && window.clipboardData.setData) {
        // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
        window.clipboardData.setData("Text", text);
    }
    else if (window.isSecureContext && navigator.clipboard) {
        // API Clipboard pour les navigateurs récents, à condition que l'on soit sur une page en HTTPS
        navigator.clipboard.writeText(text);
    }
    else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
        // Fallback
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in Microsoft Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
            document.execCommand("copy"); // Security exception may be thrown by some browsers.
        }
        catch (ex) {
            // Dernier recours
            console.warn("Copy to clipboard failed.", ex);
            prompt("Copy to clipboard: Ctrl+C, Enter", text);
        }
        finally {
            document.body.removeChild(textarea);
        }
    }
}

(function() {
    window.addEventListener('load', function() {

        // JS des boutons de copie de l'URL courante.
        const elements = Array.from(document.querySelectorAll('[data-copy-url-to-clipboard]'));
        for (const element of elements) {
            element.addEventListener('click', function() {
                copyToClipboard(document.location.href);
                element.classList.add('copy-done');
                setTimeout(function() {
                    element.classList.remove('copy-done');
                }, 3000);
            });
        }
    })
})();